import { FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useGetMe } from 'src/api/user';
import { PageLoader } from 'src/components/PageLoader';
import { AppLayout } from 'src/layouts';
import { RoleEnum } from 'src/types';

import { routes } from '../routes';

type Props = {
  allowedRoles: RoleEnum[];
};

const { accountNotActivated, accountNotActive, accountUnauthorized, login } =
  routes;

const LoggedInRoutesGuard: FC<Props> = ({ allowedRoles }) => {
  const location = useLocation();
  const { data: userData, error, isPending } = useGetMe();

  if (isPending) {
    return <PageLoader visible />;
  }

  if (!userData || error) {
    return <Navigate to={login} state={{ from: location }} replace />;
  }

  if (!userData.is_activated) {
    return (
      <Navigate to={accountNotActivated} state={{ from: location }} replace />
    );
  }

  if (!userData.is_active) {
    return (
      <Navigate to={accountNotActive} state={{ from: location }} replace />
    );
  }

  if (!userData.role || !allowedRoles.includes(userData.role)) {
    return (
      <Navigate to={accountUnauthorized} state={{ from: location }} replace />
    );
  }

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};

export default LoggedInRoutesGuard;
